import React from "react";
import classNames from "classnames";

type IHorizontalHIDLayoutHocProps = {
  header: React.ReactElement;
  image: React.ReactElement;
  children: React.ReactElement | React.ReactElement[];
  className?: string;
};

const HorizontalHIDLayoutHoc: React.FC<IHorizontalHIDLayoutHocProps> = ({ header, image, children, className }) => {
  const classes = classNames("horizontal-hid-layout-hoc", className);

  return (
    <div className={classes}>
      <div className="hid-img-container desktop">{image}</div>
      <div className="hid-detail-container">
        {header}
        <div className="hid-img-container mobile">{image}</div>
        {children}
      </div>
    </div>
  );
};

export default HorizontalHIDLayoutHoc;
